import { render, staticRenderFns } from "./productCard2.vue?vue&type=template&id=6b95a49e&scoped=true"
import script from "./productCard2.vue?vue&type=script&lang=js"
export * from "./productCard2.vue?vue&type=script&lang=js"
import style0 from "./productCard2.vue?vue&type=style&index=0&id=6b95a49e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b95a49e",
  null
  
)

export default component.exports